/* eslint-disable */
import { ProductColorItem } from "../common/common";

export const protobufPackage = "store.api.store";

export interface GetCategoryRequest {
  /** If true, then do not preemptively prune the empty categories */
  preview: boolean;
}

export interface GetCategoryContentRequest {
  /** Required. English name of big category. Case insensitive. */
  bigCategoryEn: string;
  /** Required. English name of medium category. Case insensitive. */
  mediumCategoryEn: string;
}

/** Category defines the category hierarchy. */
export interface Category {
  bigCategories: Category_BigCategory[];
}

/** BigCategory defines the collection of MediumCategory. */
export interface Category_BigCategory {
  /** big category name */
  name: string;
  /** big category english name */
  nameEn: string;
  /** medium categories */
  mediumCategories: Category_BigCategory_MediumCategory[];
}

/** MediumCategory defines the collection of SmallCategory. */
export interface Category_BigCategory_MediumCategory {
  /** medium category name */
  name: string;
  /** medium category english name */
  nameEn: string;
  /** small categories */
  smallCategories: Category_BigCategory_MediumCategory_SmallCategory[];
  /** is authorized */
  isAuthorized: boolean;
}

/** SmallCategory defines an item of small category. */
export interface Category_BigCategory_MediumCategory_SmallCategory {
  /** small category name */
  name: string;
  /** small category english name */
  nameEn: string;
  /** category icon, 180x180 pixels */
  hash: string;
}

/** CategoryContent defines the category contents. */
export interface CategoryContent {
  /** medium category name */
  name: string;
  /** medium category english name */
  nameEn: string;
  /** medium category contents */
  contents: CategoryContent_SmallContent[];
}

export interface CategoryContent_SmallContent {
  /** small category name */
  name: string;
  /** small category english name */
  nameEn: string;
  /** small category contents */
  contents: CategoryContent_SmallContent_SubContent[];
}

export interface CategoryContent_SmallContent_SubContent {
  /** sub category id */
  id: string;
  /** sub category name */
  name: string;
  /** category items */
  content: ProductColorItem | undefined;
}

function createBaseGetCategoryRequest(): GetCategoryRequest {
  return { preview: false };
}

export const GetCategoryRequest = {
  fromJSON(object: any): GetCategoryRequest {
    return { preview: isSet(object.preview) ? Boolean(object.preview) : false };
  },

  toJSON(message: GetCategoryRequest): unknown {
    const obj: any = {};
    message.preview !== undefined && (obj.preview = message.preview);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryRequest>, I>>(base?: I): GetCategoryRequest {
    return GetCategoryRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetCategoryRequest>, I>>(object: I): GetCategoryRequest {
    const message = createBaseGetCategoryRequest();
    message.preview = object.preview ?? false;
    return message;
  },
};

function createBaseGetCategoryContentRequest(): GetCategoryContentRequest {
  return { bigCategoryEn: "", mediumCategoryEn: "" };
}

export const GetCategoryContentRequest = {
  fromJSON(object: any): GetCategoryContentRequest {
    return {
      bigCategoryEn: isSet(object.bigCategoryEn) ? String(object.bigCategoryEn) : "",
      mediumCategoryEn: isSet(object.mediumCategoryEn) ? String(object.mediumCategoryEn) : "",
    };
  },

  toJSON(message: GetCategoryContentRequest): unknown {
    const obj: any = {};
    message.bigCategoryEn !== undefined && (obj.bigCategoryEn = message.bigCategoryEn);
    message.mediumCategoryEn !== undefined && (obj.mediumCategoryEn = message.mediumCategoryEn);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryContentRequest>, I>>(base?: I): GetCategoryContentRequest {
    return GetCategoryContentRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetCategoryContentRequest>, I>>(object: I): GetCategoryContentRequest {
    const message = createBaseGetCategoryContentRequest();
    message.bigCategoryEn = object.bigCategoryEn ?? "";
    message.mediumCategoryEn = object.mediumCategoryEn ?? "";
    return message;
  },
};

function createBaseCategory(): Category {
  return { bigCategories: [] };
}

export const Category = {
  fromJSON(object: any): Category {
    return {
      bigCategories: Array.isArray(object?.bigCategories)
        ? object.bigCategories.map((e: any) => Category_BigCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Category): unknown {
    const obj: any = {};
    if (message.bigCategories) {
      obj.bigCategories = message.bigCategories.map((e) => e ? Category_BigCategory.toJSON(e) : undefined);
    } else {
      obj.bigCategories = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Category>, I>>(base?: I): Category {
    return Category.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Category>, I>>(object: I): Category {
    const message = createBaseCategory();
    message.bigCategories = object.bigCategories?.map((e) => Category_BigCategory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCategory_BigCategory(): Category_BigCategory {
  return { name: "", nameEn: "", mediumCategories: [] };
}

export const Category_BigCategory = {
  fromJSON(object: any): Category_BigCategory {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      nameEn: isSet(object.nameEn) ? String(object.nameEn) : "",
      mediumCategories: Array.isArray(object?.mediumCategories)
        ? object.mediumCategories.map((e: any) => Category_BigCategory_MediumCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Category_BigCategory): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.nameEn !== undefined && (obj.nameEn = message.nameEn);
    if (message.mediumCategories) {
      obj.mediumCategories = message.mediumCategories.map((e) =>
        e ? Category_BigCategory_MediumCategory.toJSON(e) : undefined
      );
    } else {
      obj.mediumCategories = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Category_BigCategory>, I>>(base?: I): Category_BigCategory {
    return Category_BigCategory.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Category_BigCategory>, I>>(object: I): Category_BigCategory {
    const message = createBaseCategory_BigCategory();
    message.name = object.name ?? "";
    message.nameEn = object.nameEn ?? "";
    message.mediumCategories =
      object.mediumCategories?.map((e) => Category_BigCategory_MediumCategory.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCategory_BigCategory_MediumCategory(): Category_BigCategory_MediumCategory {
  return { name: "", nameEn: "", smallCategories: [], isAuthorized: false };
}

export const Category_BigCategory_MediumCategory = {
  fromJSON(object: any): Category_BigCategory_MediumCategory {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      nameEn: isSet(object.nameEn) ? String(object.nameEn) : "",
      smallCategories: Array.isArray(object?.smallCategories)
        ? object.smallCategories.map((e: any) => Category_BigCategory_MediumCategory_SmallCategory.fromJSON(e))
        : [],
      isAuthorized: isSet(object.isAuthorized) ? Boolean(object.isAuthorized) : false,
    };
  },

  toJSON(message: Category_BigCategory_MediumCategory): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.nameEn !== undefined && (obj.nameEn = message.nameEn);
    if (message.smallCategories) {
      obj.smallCategories = message.smallCategories.map((e) =>
        e ? Category_BigCategory_MediumCategory_SmallCategory.toJSON(e) : undefined
      );
    } else {
      obj.smallCategories = [];
    }
    message.isAuthorized !== undefined && (obj.isAuthorized = message.isAuthorized);
    return obj;
  },

  create<I extends Exact<DeepPartial<Category_BigCategory_MediumCategory>, I>>(
    base?: I,
  ): Category_BigCategory_MediumCategory {
    return Category_BigCategory_MediumCategory.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Category_BigCategory_MediumCategory>, I>>(
    object: I,
  ): Category_BigCategory_MediumCategory {
    const message = createBaseCategory_BigCategory_MediumCategory();
    message.name = object.name ?? "";
    message.nameEn = object.nameEn ?? "";
    message.smallCategories =
      object.smallCategories?.map((e) => Category_BigCategory_MediumCategory_SmallCategory.fromPartial(e)) || [];
    message.isAuthorized = object.isAuthorized ?? false;
    return message;
  },
};

function createBaseCategory_BigCategory_MediumCategory_SmallCategory(): Category_BigCategory_MediumCategory_SmallCategory {
  return { name: "", nameEn: "", hash: "" };
}

export const Category_BigCategory_MediumCategory_SmallCategory = {
  fromJSON(object: any): Category_BigCategory_MediumCategory_SmallCategory {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      nameEn: isSet(object.nameEn) ? String(object.nameEn) : "",
      hash: isSet(object.hash) ? String(object.hash) : "",
    };
  },

  toJSON(message: Category_BigCategory_MediumCategory_SmallCategory): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.nameEn !== undefined && (obj.nameEn = message.nameEn);
    message.hash !== undefined && (obj.hash = message.hash);
    return obj;
  },

  create<I extends Exact<DeepPartial<Category_BigCategory_MediumCategory_SmallCategory>, I>>(
    base?: I,
  ): Category_BigCategory_MediumCategory_SmallCategory {
    return Category_BigCategory_MediumCategory_SmallCategory.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Category_BigCategory_MediumCategory_SmallCategory>, I>>(
    object: I,
  ): Category_BigCategory_MediumCategory_SmallCategory {
    const message = createBaseCategory_BigCategory_MediumCategory_SmallCategory();
    message.name = object.name ?? "";
    message.nameEn = object.nameEn ?? "";
    message.hash = object.hash ?? "";
    return message;
  },
};

function createBaseCategoryContent(): CategoryContent {
  return { name: "", nameEn: "", contents: [] };
}

export const CategoryContent = {
  fromJSON(object: any): CategoryContent {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      nameEn: isSet(object.nameEn) ? String(object.nameEn) : "",
      contents: Array.isArray(object?.contents)
        ? object.contents.map((e: any) => CategoryContent_SmallContent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CategoryContent): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.nameEn !== undefined && (obj.nameEn = message.nameEn);
    if (message.contents) {
      obj.contents = message.contents.map((e) => e ? CategoryContent_SmallContent.toJSON(e) : undefined);
    } else {
      obj.contents = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryContent>, I>>(base?: I): CategoryContent {
    return CategoryContent.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CategoryContent>, I>>(object: I): CategoryContent {
    const message = createBaseCategoryContent();
    message.name = object.name ?? "";
    message.nameEn = object.nameEn ?? "";
    message.contents = object.contents?.map((e) => CategoryContent_SmallContent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCategoryContent_SmallContent(): CategoryContent_SmallContent {
  return { name: "", nameEn: "", contents: [] };
}

export const CategoryContent_SmallContent = {
  fromJSON(object: any): CategoryContent_SmallContent {
    return {
      name: isSet(object.name) ? String(object.name) : "",
      nameEn: isSet(object.nameEn) ? String(object.nameEn) : "",
      contents: Array.isArray(object?.contents)
        ? object.contents.map((e: any) => CategoryContent_SmallContent_SubContent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CategoryContent_SmallContent): unknown {
    const obj: any = {};
    message.name !== undefined && (obj.name = message.name);
    message.nameEn !== undefined && (obj.nameEn = message.nameEn);
    if (message.contents) {
      obj.contents = message.contents.map((e) => e ? CategoryContent_SmallContent_SubContent.toJSON(e) : undefined);
    } else {
      obj.contents = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryContent_SmallContent>, I>>(base?: I): CategoryContent_SmallContent {
    return CategoryContent_SmallContent.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CategoryContent_SmallContent>, I>>(object: I): CategoryContent_SmallContent {
    const message = createBaseCategoryContent_SmallContent();
    message.name = object.name ?? "";
    message.nameEn = object.nameEn ?? "";
    message.contents = object.contents?.map((e) => CategoryContent_SmallContent_SubContent.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCategoryContent_SmallContent_SubContent(): CategoryContent_SmallContent_SubContent {
  return { id: "", name: "", content: undefined };
}

export const CategoryContent_SmallContent_SubContent = {
  fromJSON(object: any): CategoryContent_SmallContent_SubContent {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      name: isSet(object.name) ? String(object.name) : "",
      content: isSet(object.content) ? ProductColorItem.fromJSON(object.content) : undefined,
    };
  },

  toJSON(message: CategoryContent_SmallContent_SubContent): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.name !== undefined && (obj.name = message.name);
    message.content !== undefined &&
      (obj.content = message.content ? ProductColorItem.toJSON(message.content) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryContent_SmallContent_SubContent>, I>>(
    base?: I,
  ): CategoryContent_SmallContent_SubContent {
    return CategoryContent_SmallContent_SubContent.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CategoryContent_SmallContent_SubContent>, I>>(
    object: I,
  ): CategoryContent_SmallContent_SubContent {
    const message = createBaseCategoryContent_SmallContent_SubContent();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.content = (object.content !== undefined && object.content !== null)
      ? ProductColorItem.fromPartial(object.content)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
